<template>
  <div>
    <div class="page_title">患者使用协议</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div>
          <el-button type="primary" icon="el-icon-edit" @click="Add" v-if="edit">编辑协议</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="Add" v-else>添加协议</el-button>
        </div>
        <div class="essaybox" v-if="edit">
          <div class="title">{{detail.title}}</div>
          <div v-html="detail.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import imgtext from "../../../api/imgtext";
import platform from "../../../api/platform";
export default {
  data() {
    return {
      detail: {},
      edit: false
    };
  },

  methods: {
    //获取图文信息
    getDetail() {
      let art_id = 2;
      imgtext.getArticleInfo({ art_id }).then(res => {
        if (res.code == 0) {
          this.detail = res.data.info;
          if (this.detail.content) {
            this.edit = true;
          }
        }
      });
    },

    //添加文章
    Add() {
      this.$router.push("adduse");
    }
  },
  created() {
    this.getDetail();
  }
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  text-align: left;
}
.essaybox {
  width: 70%;
  padding: 30px 50px;
  box-sizing: border-box;
  border: solid 2px #cfcece;
  margin: 20px auto 0;
  text-align: left;
  min-height: calc(100vh - 240px);

  .title {
    font-size: 18px;
    font-weight: 700;
  }
  .date {
    font-size: 12px;
    color: #737373;
    margin: 10px 0 30px;
  }
}
</style>

